import React, { useEffect, useState } from 'react';
import ProductCarousel from './common/productCarousel.jsx';
import useFetch from './common/useFetch.jsx';

/**
 * Generates the My Recent Products component
 *
 * @returns {JSX.Element}
 * @constructor
 */
const MyRecentProducts = () => {
	const [data, setData] = useState(null);
	const options = {
		infinite: false,
		slidesToShow: 7,
		slidesToScroll: 7,
		speed: 500,
		swipeToSlide: true,
		responsive: [
			{
				breakpoint: 1089,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
		]
	};

	const getWhereLeftOffServices = '/internal/dynamic-home-api/Ajax/Ajax.php?action=GetWhereLeftOff&limit=20';
	const { response, loading, error } = useFetch(getWhereLeftOffServices);
	const title = <>My Recent Products</>;

	/**
	 * Listens for changes in response state.
	 * setData method called when data is response is ready
	 *
	 */
	useEffect(() => {
		if (response !== null) {
			setData(
				Object.entries(response.payload)
					.reduce((products, line) => {
						line[1].reduce((acc, productItem)=>{
							const item = Object.entries(productItem);

							products = [
								...products,
								{
									uuid: item[0][0],
									title: item[0][1].title,
									url: item[0][1].url,
									image: item[0][1].image,
									productType: item[0][1].productType
								}
							];
						}, []);

						return products;
					}, [])
			);
		}
	}, [response]);

	return (
		<div className={'my-recent-products'}>
			<ProductCarousel
				options={options}
				error={error}
				loading={loading}
				data={data}
				title={title}
				alt={'My Recent Products'} />
		</div>
	);
};

export default MyRecentProducts;
